import React, { useCallback } from 'react'
import { Image, StyleSheet } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Button, SH2, Stack, XStack } from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { navigateTo } from '@zet/utils/navigation'
import { LinearGradient } from 'expo-linear-gradient'
import { styled } from 'nativewind'

import { CBMBannerDetailsUrl, CBMIllustration } from '../../utils/constants'

const LinearGradientStyled = styled(LinearGradient, 'h-0.5 w-1/4')

interface IProps {
  sectionTitle: string
}

const CbmCrossSell: React.FC<IProps> = ({ sectionTitle }) => {
  const handleKnowMore = useCallback(() => {
    navigateTo('CreditBuilderLoans')
  }, [])

  const gradientProps = {
    start: { x: 0, y: 0 },
    end: { x: 1, y: 1 },
    locations: [0, 1],
  }

  if (APP_NAME === MY_TEAMS_ADVISOR) {
    return <></>
  }

  return (
    <>
      {sectionTitle ? (
        <XStack className="items-center justify-between bg-white p-2">
          <LinearGradientStyled
            {...gradientProps}
            colors={['#FFFFFF', '#5E9FFF']}
          />
          <SH2 className="text-primary-150">{sectionTitle}</SH2>
          <LinearGradientStyled
            {...gradientProps}
            colors={['#5E9FFF', '#FFFFFF']}
          />
        </XStack>
      ) : null}
      <Stack className="bg-white p-3">
        <LinearGradient
          colors={['#FFFDFA', '#F9CB90']}
          style={styles.container}
          className="items-center border"
        >
          <Stack style={styles.img1}>
            <Image
              className="h-full w-full"
              resizeMode="contain"
              source={{ uri: CBMBannerDetailsUrl }}
            />
          </Stack>
          <Stack style={styles.img2}>
            <Image
              className="h-full w-full items-center justify-end"
              resizeMode="contain"
              source={{ uri: CBMIllustration }}
            />
          </Stack>
          <Stack style={styles.btnContainer}>
            <LinearGradient
              className="h-6 w-full"
              colors={['#FBD9AF00', '#FAD19D']}
              start={[1, 0]}
              end={[1, 1]}
            />
            <Button
              onPress={handleKnowMore}
              textStyle={'text-tertiary-200'}
              className={'w-full bg-white'}
            >
              {i18n.t('knowMore')}
            </Button>
          </Stack>
        </LinearGradient>
      </Stack>
    </>
  )
}

export default CbmCrossSell

const styles = StyleSheet.create({
  container: {
    borderColor: '#E6C8A2',
    borderRadius: 20,
  },
  img1: {
    width: '90%',
    height: 110,
    marginTop: 20,
  },
  img2: {
    width: '100%',
    height: 250,
    marginTop: -5,
  },
  btnContainer: {
    width: DEVICE_WIDTH * 0.83,
    marginTop: -62,
    marginBottom: 20,
  },
})
